export default __webpack_public_path__ + "static/media/wanli.92eda64c.jpg";